<template>
  <div class="mainBox">
    <h2 style="margin-top:20px;">搜索结果</h2>
    <ul class="imageBlock">
        <li v-for="item in tableData" :key="item.articleId">
          <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank"><img :src="item.smallPic" class="img" /> </router-link>
          <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank"><img :src="item.reverseSmallPic" class="img" /></router-link>
            
              <div class="txt">
                  <h3> 
                    <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank">
                    <div v-if=" item.bigType == 246 || item.bigType==247 || item.bigType==248 || item.bigType==249 
                    || item.bigType==250 || item.bigType==253 || item.bigType==254 || item.bigType==255 
                    || item.bigType==256 || item.bigType==257 || item.bigType==258 || item.bigType==259 ">
                      <span v-if="item.country!=undefined && item.country.length>0"><span v-html="item.country"></span></span><span v-if="item.frontDesc!=undefined && item.frontDesc.length>0">-<span v-html="item.frontDesc"></span></span><span v-if="item.classifyName!=undefined && item.classifyName.length>0">-<span v-html="item.classifyName"></span></span><span><span v-html="item.castMark"></span></span>
                    </div>
                    <div v-else>
                      <span v-if="item.country!=undefined && item.country.length>0"><span v-html="item.country"></span></span><span v-if="item.classifyName!=undefined && item.classifyName.length>0">-<span v-html="item.classifyName"></span></span><span v-if="item.thisYear!=undefined && item.thisYear.length>0">-<span v-html="item.thisYear"></span></span><span><span v-html="item.castMark"></span></span>
                    </div>
                  </router-link>
                </h3>
                <i style="color:#333;"><span v-if="item.coinTypeName!=undefined && item.coinTypeName.length>0"><span v-html="item.coinTypeName"></span></span><span v-if="item.weight!=undefined && item.weight.length>0">,<span v-html="item.weight"></span>克</span><span v-if="item.diameter!=undefined && item.diameter.length>0">,<span v-html="item.diameter"></span>毫米</span><span v-if="item.thick!=undefined && item.thick.length>0">,<span v-html="item.thick"></span>毫米</span></i><br />
                <i style="color:#333;"><span v-if="item.component!=undefined && item.component.length>0"><span v-html="item.component"></span></span> <span v-if="item.shape!=undefined && item.shape.length>0">,<span v-html="item.shape"></span></span> <span v-if="item.edge!=undefined && item.edge.length>0">,<span v-html="item.edge"></span></span></i><br />
                <span style="color:#666;"><span v-html="item.frontDesc"></span></span><br />
                <span style="color:#666;"><span v-html="item.backDesc"></span></span>
              </div>
           
           
            <div style="clear:both;"></div>
        
          
        </li>
      </ul>
    <div class="tabListPage">
           <el-pagination @size-change="handleSizeChange" 
                          @current-change="handleCurrentChange" 
                          :current-page="currentPage" 
                          :page-sizes="pageSizes" 
                          :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                          :total="totalCount">
             </el-pagination>
    </div>    
  </div>
</template>


<script>
  import axios from "axios";

  export default {
      components: {

      },
      data(){
          return{
                   // 总数据
                  tableData:[],
                  // 默认显示第几页
                  currentPage:1,
                  // 总条数，根据接口获取数据长度(注意：这里不能为空)
                  totalCount:1,
                  // 个数选择器（可修改）
                  pageSizes:[10],
                  // 默认每页显示的条数（可修改）
                  PageSize:10,
                  title:""

                  
          }
      },
      created:function(){
         this.getData(this.currentPage) 
      },
      methods:{
        getData(currentPage){
              var _this = this;
              this.title = this.$route.query.so;
              console.log(this.title);
              axios.get(this.COMMON.httpUrl + '/api/article/fullSearch', {
              params: {
                page: currentPage,
                limit: _this.PageSize,
                title:this.title
              }
            }).then(function (response) {
              var data = response.data;
              _this.tableData=data.data;
              _this.totalCount = data.count;
            }).catch(function (error) {
              console.log(error)
            });
          },
        // 分页
          // 每页显示的条数
        handleSizeChange(val) {
            // 改变每页显示的条数 
            this.PageSize=val
            // 注意：在改变每页显示的条数时，要将页码显示到第一页
            this.currentPage=1
        },
          // 显示第几页
        handleCurrentChange(val) {
            // 改变默认的页数
            this.currentPage=val
            this.getData(val);
        },
    },
      // 侦听器
      watch:{
        //监听路由
        //监听路由的categoryId属性的数据变化
        '$route.query.so': function(){
          // 只要categoryId的值发生变化,这个方法就会被调用
          this.title=this.$route.query.so
          //重新调用请求数据的方法，刷新页面数据
          this.getData(this.currentPage) 
        }
      },

  }
</script>


<style scoped>


ul.imageBlock{ width: 100%; overflow: hidden; margin-top: 20px;}
ul.imageBlock li{width: 100%;min-height: 135px; overflow: hidden; padding-bottom: 20px; border-bottom: 1px solid #ccc; margin-bottom: 20px; }
ul.imageBlock li img{border: 1px solid #E5E5E5; float: left; margin-right: 10px; margin-bottom: 5px;width: 140px; height: 140px;}
ul.imageBlock li .txt{margin-left: 10px; float:left;line-height: 180%;overflow: hidden; width: 500px;}
ul.imageBlock li .txt h3{font-size: 20px; margin-bottom: 6px;}
ul.imageBlock li .txt h3 a{text-decoration: none;color: rgb(179, 0, 0);}
.fixedNavbar {
      position:fixed;
      z-index: 2032;
      top: 10px;
      height: 1000px;
      float: both;
    }
.img{border-radius: 10px;}
</style>
